var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden md:flex flex-col justify-center items-end px-0 border-r border-gray-500 print:!border-b print:!flex print:!items-center"},[_c('div',{staticClass:"text-base -rotate-90 print:text-sm"},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }